import React, {FC} from 'react';
import Transfer from "../../transfers/types/Transfer";
import useTranslate from "../../core/languages/hooks/useTranslate";
import TitleCardSection from "./TitleCardSection";

interface PersonalDetailsSectionProps {
  transferInfo: Transfer;
}

const PersonalDetailsSection: FC<PersonalDetailsSectionProps> = ({transferInfo}) => {
  const t = useTranslate();

  return (
    <div className="mb-10">
      <TitleCardSection
          title={t("transferOk.message.personalDetails")}
          subtitle={t("transferOk.message.personalDetailsSubtitle")}
      />
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <div
          className="bg-gradient-to-br from-neutral-50 to-neutral-100 dark:from-neutral-800 dark:to-neutral-900 rounded-2xl p-4 border border-neutral-200 dark:border-neutral-700">
          <div className="flex items-center space-x-3">
            <div className="flex-shrink-0">
              <i className="las la-user text-indigo-600 dark:text-indigo-400 text-2xl"></i>
            </div>
            <div className="flex-1">
              <p className="text-xs font-medium text-neutral-500 dark:text-neutral-400 uppercase tracking-wide">
                {t("transferOk.fields.nameAndSurnames")}
              </p>
              <p className="text-sm font-semibold text-neutral-900 dark:text-neutral-100 mt-1">
                {transferInfo.passengerName} {transferInfo.passengerLastName}
              </p>
            </div>
          </div>
        </div>

        <div
          className="bg-gradient-to-br from-neutral-50 to-neutral-100 dark:from-neutral-800 dark:to-neutral-900 rounded-2xl p-4 border border-neutral-200 dark:border-neutral-700">
          <div className="flex items-center space-x-3">
            <div className="flex-shrink-0">
              <i className="las la-envelope text-indigo-600 dark:text-indigo-400 text-2xl"></i>
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-xs font-medium text-neutral-500 dark:text-neutral-400 uppercase tracking-wide">
                {t("transfers.fields.passengerContactEmail")}
              </p>
              <p className="text-sm font-semibold text-neutral-900 dark:text-neutral-100 mt-1 truncate">
                {transferInfo.passengerContactEmail}
              </p>
            </div>
          </div>
        </div>

        <div
          className="bg-gradient-to-br from-neutral-50 to-neutral-100 dark:from-neutral-800 dark:to-neutral-900 rounded-2xl p-4 border border-neutral-200 dark:border-neutral-700">
          <div className="flex items-center space-x-3">
            <div className="flex-shrink-0">
              <i className="las la-phone text-indigo-600 dark:text-indigo-400 text-2xl"></i>
            </div>
            <div className="flex-1">
              <p className="text-xs font-medium text-neutral-500 dark:text-neutral-400 uppercase tracking-wide">
                {t("transfers.fields.passengerPhoneNumber")}
              </p>
              <p className="text-sm font-semibold text-neutral-900 dark:text-neutral-100 mt-1">
                +{transferInfo.passengerDialCode} {transferInfo.passengerPhoneNumber}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonalDetailsSection;


